import React, { Component } from "react";
import { DataGrid, GridToolbar } from '@material-ui/data-grid'
import axios from 'axios';
import { Backdrop, Button,  CircularProgress,  FormControl } from "@mui/material";
import moment from 'moment';
import 'moment/locale/es';

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/schedule/find";
   
  
class FindAgenda extends Component {
    state = {
        data:[],
        openLoader: true
    }
    peticionGet = () => {
        axios.post(url, { }).then(response => { 
          
          this.setState({data: response.data});
          this.setState({openLoader: false});
        }); 
    };

    componentDidMount() {
        this.peticionGet();
    }   

    render() {
      const columns = [
            { field: 'medicalDate', headerName: 'Fecha', width: 180,
            valueGetter: (params) => 
              `${moment(params.row.medicalDate).locale('es').format('MMMM D YYYY')|| ''}`
            },
            {
                field: 'patientName',
                headerName: 'Paciente',
                description: 'Nombre Completo.',
                sortable: false,
                width: 160,
                valueGetter: (params) =>
                  `${params.row.patient.firstName || ''} ${params.row.patient.secondLastName || ''}`,
              }, 
              { field: 'purpose', headerName: 'Finalidad', width: 140 },
              {
                field: 'medicalName',
                headerName: 'Medico',
                description: 'Nombre Completo.',
                sortable: false,
                width: 160,
                valueGetter: (params) =>
                  `${params.row.medicalTeam.firstName || ''} ${params.row.medicalTeam.secondLastName || ''}`,
              }, 
              { field: 'typeDate', headerName: 'Tipo', width: 220 },
              { field: 'starHour', headerName: 'Hora', width: 140 ,
              valueGetter: (params) => 
                `${moment(params.row.starHour).format('hh:mm:ss a')|| ''}`
              }
        ];

        return (
            <div style={{ height: 700, width: '100%' }}>
                    <FormControl>
                        <Button variant="contained"  color="primary" onClick={() => {
                            this.props.setAffiliate({})
                            this.props.setMedicalTeam({})
                            this.props.changeMenu(11);
                        }}>
                            Nueva Cita
                        </Button>   
                    </FormControl>
                   
              <DataGrid
               initialState={{
                sorting: {
                  sortModel: [{ field: 'medicalDate', sort: 'asc' }],
                },
              }}
                rows={this.state.data}
                columns={columns}
                pagination
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowCount={100}
                //paginationMode="server"
                checkboxSelection={true}
                //autoPageSize={true}
                
                componentsProps={{
                    columnMenu: { background: 'red', counter: this.state.data.length },
                  }}
                  components={{
                    Toolbar: GridToolbar,
                  }}
              />

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.openLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
            </div>
          )
    }
}

export default FindAgenda;
